<template>
  <div class="leave-mangement" >
    <div class="cards-container">
      <div
        class="card"
        v-for="(card, index) in cards"
        :key="index"
        :style="{ borderColor: card.color }"
      >
         <div class="card-content">
          <div class="card-mian">
            <h2 :style="{ color: card.color }">{{ card.value }}</h2>
            <i  class="fa fa-info-circle pointer info-icon" @mouseenter="showInfo($event, card)" @mouseleave="hideInfo"v-if="showScoreInfo && card.hasTooltip" ></i>
          </div>
          <p>{{ card.label }}</p>
          <p>{{ }}</p>
        </div>
      </div>
    </div>
    <div v-if="showTooltip && currentCard" class="performance-tooltip" :style="{ top: tooltipY + 'px', left: tooltipX + 'px' }" @mouseenter="keepTooltip" @mouseleave="hideInfo" style="overflow-y: auto;">
  <div style="width: 100%; text-align: center; font-weight: bold; margin-bottom: 8px;"> Score Summary</div>
  
  <div
    v-if="currentCard.typeBreakdown && currentCard.typeBreakdown.length"
    style=" padding: 6px 0; border-top: 1px solid #eee;  width: 100%;"
  >
    <div
      v-for="item in currentCard.typeBreakdown"
      :key="item.type"
      style="display: flex; justify-content: space-between; font-size: 0.9em; color: #444; margin: 5px 0;"
    >
      <span>→ {{ item.type }}</span>
      <span>{{ item.sum.toFixed(1) }}</span>
    </div>
    <div style="display: flex; justify-content: space-between; width: 100%; font-size: 14px; padding: 4px 0; font-weight: bold; padding-top:6px">
    <span>Gross Score:</span>
    <span>{{ currentCard.grossScore.toFixed(1) }}</span>
  </div>
  </div>
  <div v-if="currentCard.reopenDeduction !== null || currentCard.deadlineDeduction !== null" style=" border-top: 1px solid #eee; padding-top:8px; width:100%">
    <div v-if="currentCard.reopenDeduction !== null" style="display:flex; justify-content:space-between; color:#ff4d4d; width:100%">
        <span>Reopen Deductions:</span> <span>{{ currentCard.reopenDeduction.toFixed(1) }}</span>
    </div>
    <div v-if="currentCard.deadlineDeduction !== null" style="display:flex; justify-content:space-between; color:#ff8c00; margin-bottom:8px; width:100%">
      <span>Deadlines Deductions:</span> <span>{{ currentCard.deadlineDeduction.toFixed(1) }}</span>
    </div>
  </div>
    <!-- <hr style="margin: 8px 0; border-color: #ddd;" /> -->
    <div style="display: flex; justify-content: space-between; font-size: 14px; padding: 6px 0; font-weight: bolder; border-top: 1px solid #eee; width: 100%; padding-top:8px"><span>Net Score:</span> <span>{{ currentCard.value }}</span></div>
    </div>
  </div>
</template>
<script>
export default  {
  name: "CardsSection",
  props: {
    cards: {
      type: Array,
      required: true,
    },
    showScoreInfo: {
      type: Boolean,
      default: false
    },
  },
  data() { return { showTooltip: false, tooltipX: 0, tooltipY: 0, currentCard: null,hideTimeout: null,};},
  methods: {
    showInfo(event, card) {
      clearTimeout(this.hideTimeout);
      this.currentCard = card;
      this.showTooltip = true;
      const rect = event.currentTarget.getBoundingClientRect();
      this.tooltipX = rect.left + rect.width / 2;
      this.tooltipY = rect.bottom + 10; // below icon
    },
    hideInfo() {
      this.hideTimeout = setTimeout(() => {
        this.showTooltip = false;
        this.currentCard = null;
      }, 200);
    },

    keepTooltip() {
      clearTimeout(this.hideTimeout);
      this.showTooltip = true;
    },
  },
};
</script>
<style scoped>

.performance-tooltip {
  position: fixed !important; 
  background: #fff;
  border: 1px solid #ccc;
  padding: 10px;
  width: 220px;
  z-index: 9999 !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  pointer-events: auto !important; 
}
</style>


// WEBPACK FOOTER //
// src/components/LeaveManagement/CardsSection.vue